export const errorHandler = {
  notInActivity: 'Technician is not signed in to any activity',
  alreadyInShift: 'Technician already in Begin Shift'
};
